<template>
  <el-card shadow="always" :body-style="{ padding: '20px', height: '72vh' }">
    <div slot="header">
      <div>
        <img src="@/assets/home/new.png" alt="" />
        <span class="hardtext">装配式构件出厂统计</span>
        <!-- <span style="color: #409eff;font-weight: bold;font-size: 18px;"
          ></span
        > -->
      </div>
    </div>
    <!-- card body -->
    <div>
      <el-descriptions
        class="margin-top"
        style="width: 100%"
        :column="3"
        border
      >
        <el-descriptions-item>
          <template slot="label"> 横轴单位 </template>
          <el-input size="normal" v-model="clun.clun03" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 纵轴单位 </template>
          <el-input size="normal" v-model="clun.clun04" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"></template>
          <div class="flex" style="justify-content: space-between;">
            <div>
              <el-button type="primary" @click="AddOrUpdateClUnit()"
                >保存</el-button
              >
            </div>
            <div>
              <el-button type="primary" @click="dialogVisible = true"
                >添加</el-button
              >
              <!-- <el-button type="success">导入</el-button> -->
            </div>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <el-table
        style="margin-top: 20px"
        align="center"
        stripe
        :data="WorktableData"
        :header-cell-style="{
          background: '#EBEFF2',
          color: '#1E2134',
          fontWeight: 'bold',
        }"
      >
        <el-table-column
          align="center"
          type="index"
          label="序号"
          width="80"
        ></el-table-column>
        <el-table-column align="center">
          <template slot="header">
            <div
              v-if="!tableTitle[0].inputshow"
              @dblclick="bccelldblclick(tableTitle[0], 'saveTagInput1')"
            >
              横轴 - {{ tableTitle[0].tist05 }}
            </div>
            <el-input
              v-else
              ref="saveTagInput1"
              @blur="bccellblur(tableTitle[0])"
              v-model="tableTitle[0].tist05"
              size="mini"
            />
          </template>
          <template slot-scope="scope">
            {{ scope.row.cmlv03 }}
          </template>
        </el-table-column>
        <el-table-column align="center">
          <template slot="header">
            <div
              v-if="!tableTitle[1].inputshow"
              @dblclick="bccelldblclick(tableTitle[1], 'saveTagInput2')"
            >
              纵轴1 - {{ tableTitle[1].tist05 }}
            </div>
            <el-input
              v-else
              ref="saveTagInput2"
              @blur="bccellblur(tableTitle[1])"
              v-model="tableTitle[1].tist05"
              size="mini"
            />
          </template>
          <template slot-scope="scope">
            {{ scope.row.cmlv04 }}
          </template>
        </el-table-column>
        <el-table-column align="center">
          <template slot="header">
            <div
              v-if="!tableTitle[2].inputshow"
              @dblclick="bccelldblclick(tableTitle[2], 'saveTagInput3')"
            >
              纵轴2 - {{ tableTitle[2].tist05 }}
            </div>
            <el-input
              ref="saveTagInput3"
              v-else
              @blur="bccellblur(tableTitle[2])"
              v-model="tableTitle[2].tist05"
              size="mini"
            />
          </template>
          <template slot-scope="scope">
            {{ scope.row.cmlv05 }}
          </template>
        </el-table-column>
        <el-table-column align="center">
          <template slot="header">
            <div
              v-if="!tableTitle[3].inputshow"
              @dblclick="bccelldblclick(tableTitle[3], 'saveTagInput4')"
            >
              纵轴3 - {{ tableTitle[3].tist05 }}
            </div>
            <el-input
              ref="saveTagInput4"
              v-else
              @blur="bccellblur(tableTitle[3])"
              v-model="tableTitle[3].tist05"
              size="mini"
            />
          </template>
          <template slot-scope="scope">
            {{ scope.row.cmlv06 }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="添加人" prop="cmlv07">
        </el-table-column>
        <el-table-column align="center" label="添加时间" prop="cmlv08">
        </el-table-column>
        <el-table-column align="right" label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="updateGoodsDetailed(scope.row)"
              >编辑</el-button
            >
            <el-popconfirm
              title="确定删除这条数据吗？"
              @confirm="delDown(scope.row)"
            >
              <el-button
                type="danger"
                style="margin-left: 10px;"
                slot="reference"
                size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float: right"
        background
        @size-change="DownhandleSizeChange"
        @current-change="DownhandleCurrentChange"
        :current-page.sync="DonwpageIndex"
        :page-size="DonwpageSize"
        layout="prev, pager, next, jumper"
        :total="Donwtotal"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="添加"
      :visible.sync="dialogVisible"
      width="55%"
      :before-close="handleClose"
    >
      <span>
        <el-table
          :header-cell-style="{
            background: '#EBEFF2',
            color: '#1E2134',
            fontWeight: 'bold',
          }"
          align="center"
          stripe
          :data="list"
        >
          <el-table-column
            align="center"
            type="index"
            label="序号"
            width="80"
          ></el-table-column>
          <el-table-column
            align="center"
            :label="'横轴 - ' + tableTitle[0].tist05"
          >
            <template slot-scope="scope">
              <el-input
                size="normal"
                v-model="scope.row.cmlv03"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="'纵轴1 - ' + tableTitle[1].tist05"
          >
            <template slot-scope="scope">
              <el-input
                size="normal"
                v-model="scope.row.cmlv04"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="'纵轴2 - ' + tableTitle[2].tist05"
          >
            <template slot-scope="scope">
              <el-input
                size="normal"
                v-model="scope.row.cmlv05"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="'纵轴3 - ' + tableTitle[3].tist05"
          >
            <template slot-scope="scope">
              <el-input
                size="normal"
                v-model="scope.row.cmlv06"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="list.push({})"
                >+</el-button
              >
              <el-button
                type="danger"
                size="small"
                @click="list.splice(scope.$index, 1)"
                >-</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      title="编辑"
      :visible.sync="updatedialogVisible"
      width="45%"
      :before-close="handleClose"
    >
      <div style="padding:0px 10% 0px 10%">
        <el-form ref="form" :model="form" label-width="160px">
          <el-form-item :label="tableTitle[0].tist05">
            <el-input v-model="form.cmlv03"></el-input>
          </el-form-item>
          <el-form-item :label="tableTitle[1].tist05">
            <el-input v-model="form.cmlv04"></el-input>
          </el-form-item>
          <el-form-item :label="tableTitle[2].tist05">
            <el-input v-model="form.cmlv05"></el-input>
          </el-form-item>
          <el-form-item :label="tableTitle[3].tist05">
            <el-input v-model="form.cmlv06"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updatedialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdateGoodsDetailed()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  AddOrUpdateClUnit,
  GetClUnit,
  AddOrUpdateTitleSet,
  GetTitleSet,
  GetCmlvList,
  AddCmlv,
  DelCmlv,
  updateCmlv,
} from "@/setAxios";
import dayjs from "dayjs";
export default {
  name: "RunhongXUGK",
  data() {
    return {
      clun: { clun03: "", clun04: "" },
      tableTitle: [
        { tist05: "列名1", inputshow: false },
        { tist05: "列名2", inputshow: false },
        { tist05: "列名3", inputshow: false },
        { tist05: "列名4", inputshow: false },
      ],
      WorktableData: [],
      DonwpageIndex: 1,
      DonwpageSize: 10,
      Donwtotal: 0,
      dialogVisible: false,
      list: [{}],
      updatedialogVisible: false,
      form: "",
    };
  },
  mounted() {},
  created() {
    this.GetClUnit();
    this.GetClTitSet();
    this.GetCmlvList();
  },
  methods: {
    GetCmlvList() {
      let params = {
        xid: this.$store.state.xid,
        pageindex: this.DonwpageIndex,
        pageSize: this.DonwpageSize,
      };
      GetCmlvList({ params }).then((res) => {
        this.WorktableData = res.Data.list;
        this.Donwtotal = res.Data.total;
      });
    },
    addSubmit() {
      let that = this;
      this.list.map(function(i) {
        i.cmlv02 = that.$store.state.xid;
        i.cmlv07 = that.$store.state.uid;
        i.cmlv08 = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
        return i;
      });
      AddCmlv({ cmlv: this.list }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.dialogVisible = false;
          this.GetCmlvList();
        } else {
          this.$message({
            type: "error",
            message: "操作有误!",
          });
        }
      });
    },
    async delDown(row) {
      let params = {
        id: row.cmlv01,
      };
      let res = await DelCmlv(params);
      if (res.Code) {
        this.$message({
          type: "success",
          message: "移除成功!",
        });
        this.GetCmlvList();
      } else {
        this.$message({
          type: "error",
          message: "移除失败!",
        });
        return;
      }
    },
    updateGoodsDetailed(row) {
      this.updatedialogVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },
    submitUpdateGoodsDetailed() {
      this.UploadFileFrom = new FormData();
      this.UploadFileFrom.append("cmlv01", this.form.cmlv01);
      this.UploadFileFrom.append("cmlv02", this.$store.state.xid);
      this.UploadFileFrom.append("cmlv03", this.form.cmlv03);
      this.UploadFileFrom.append("cmlv04", this.form.cmlv04);
      this.UploadFileFrom.append("cmlv05", this.form.cmlv05);
      this.UploadFileFrom.append("cmlv06", this.form.cmlv06);
      updateCmlv(this.UploadFileFrom).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "编辑成功!",
          });
          this.updatedialogVisible = false;
          this.GetCmlvList();
        } else {
          this.$message({
            type: "error",
            message: "操作有误!",
          });
        }
      });
    },
    GetClUnit() {
      let params = {
        xid: this.$store.state.xid,
      };
      GetClUnit({ params }).then((res) => {
        res.Data != null ? (this.clun = res.Data) : "";
      });
    },
    async AddOrUpdateClUnit() {
      this.UploadFileFrom = new FormData();
      this.UploadFileFrom.append("clun01", this.clun.clun01);
      this.UploadFileFrom.append("clun02", this.$store.state.xid);
      this.UploadFileFrom.append("clun03", this.clun.clun03);
      this.UploadFileFrom.append("clun04", this.clun.clun04);
      let res = await AddOrUpdateClUnit(this.UploadFileFrom);
      if (res.Code) {
        this.$message({
          message: "保存成功",
          type: "success",
        });
        //刷新
        this.GetClUnit();
      }
    },
    async GetClTitSet() {
      let params = {
        xid: this.$store.state.xid,
        name: "装配式构件出厂统计",
      };
      let res = await GetTitleSet({ params });
      if (res.Data.length > 0) {
        res.Data.forEach((element) => {
          element.inputshow = false;
        });
        this.tableTitle = res.Data;
      } else {
        for (let i = 0; i < 4; i++) {
          this.UploadFileFrom = new FormData();
          this.UploadFileFrom.append("tist02", this.$store.state.xid);
          this.UploadFileFrom.append("tist03", "装配式构件出厂统计");
          this.UploadFileFrom.append("tist04", i + 1);
          this.UploadFileFrom.append("tist05", "列名" + (i + 1));
          await AddOrUpdateTitleSet(this.UploadFileFrom);
        }
      }
    },
    bccelldblclick(row, saveTagInput) {
      row.inputshow = true;
      this.$nextTick((_) => {
        this.$refs[saveTagInput].$refs.input.focus();
      });
    },
    async bccellblur(row, index) {
      row.inputshow = false;
      this.UploadFileFrom = new FormData();
      this.UploadFileFrom.append("tist02", this.$store.state.xid);
      this.UploadFileFrom.append("tist03", "装配式构件出厂统计");
      this.UploadFileFrom.append("tist04", row.tist04);
      this.UploadFileFrom.append("tist05", row.tist05);
      let res = await AddOrUpdateTitleSet(this.UploadFileFrom);
      if (res.Code) {
        this.$message({
          message: "更新成功",
          type: "success",
        });
        //刷新
        this.GetClTitSet();
      }
    },
    handleClose(done) {
      this.$confirm("确定关闭吗？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    DownhandleSizeChange(val) {
      this.DonwpageSize = val;
      this.GetCmlvList();
    },
    DownhandleCurrentChange(val) {
      this.DonwpageIndex = val;
      this.GetCmlvList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
